<script>
  /**
   * from https://tobiasahlin.com/spinkit/*
   */

  export let size = "1em";
  export let color = "#ffffff";
</script>

<style>

</style>

<svg
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  style="margin: auto; background: none; display: block; shape-rendering: auto;"
  width={size}
  height={size}
  viewBox="0 0 100 100"
  preserveAspectRatio="xMidYMid">
  <circle
    cx="50"
    cy="50"
    r="30"
    stroke={color}
    stroke-width="11"
    stroke-linecap="round"
    fill="none"
    transform="rotate(84.3096 50 50)">
    <animateTransform
      attributeName="transform"
      type="rotate"
      repeatCount="indefinite"
      dur="1.8518518518518516s"
      values="0 50 50;180 50 50;720 50 50"
      keyTimes="0;0.5;1" />
    <animate
      attributeName="stroke-dasharray"
      repeatCount="indefinite"
      dur="1.8518518518518516s"
      values="18.84955592153876 169.64600329384882;94.2477796076938
      94.24777960769377;18.84955592153876 169.64600329384882"
      keyTimes="0;0.5;1" />
  </circle>
</svg>
